import { SubmissionMarket } from 'types';
import { CapitolaClient } from './base';

export default class SubmissionMarketClient extends CapitolaClient<SubmissionMarket> {
  public get resourceName(): string {
    return 'submission-market';
  }
}
